












































import Vue from 'vue';
import { gridSize } from '@/theme/constants';

import Breadcrumbs from '../Breadcrumbs.vue';
import ALPageHeader from './ALPageHeader.vue';

export default Vue.extend({
  name: 'ALPage',

  components: { Breadcrumbs, ALPageHeader },

  props: {
    pageTitle: { type: String, default: () => '' },
    pageSubTitle: { type: String, default: () => '' },
    truncateTitle: { type: Boolean, default: () => true },
    disableTitleStyles: { type: Boolean, default: () => false },
    breadcrumbs: { type: Boolean, default: () => false },
    noHeader: { type: Boolean, default: () => false },
    fluid: { type: Boolean, default: () => true },
    stickyHeader: { type: Boolean, default: () => false },
    noPadding: { type: Boolean, default: () => false },
    noMargin: { type: Boolean, default: () => false },
    overflowX: { type: Boolean, default: () => false }
  },

  computed: {
    alPageContainerClasses(): string {
      let containerClasses = 'py-2 px-4 px-sm-6 px-md-8 px-lg-10';
      if (this.noPadding) return 'pa-0';
      if (this.overflowX) containerClasses += ' overflow-x-auto';
      return containerClasses;
    },

    pageOuterStyles(): Record<string, string> {
      return {
        margin: `0px 0px ${gridSize() * 2}px 0px`
      };
    },
    pageHeaderStyles(): Record<string, string | number> {
      if (!this.stickyHeader) return {};
      return {
        position: 'sticky',
        zIndex: 3,
        top: `${this.$vuetify.application.top}px`
      };
    }
  }
});
